<template >
  <div id="mainWrapperApp">
      <Header> </Header>
      <!-- <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in"> -->
        <router-view style="animation-duration: 0.2s"></router-view>
      <!-- </transition> -->
      <Footer > </Footer>
      <GoTop :boundary="10" :size="45" bg-color="#6666" :bottom="30" :right="'94%'"></GoTop>
      <FormWidget></FormWidget>
  </div>
</template>

<script>
import Header from "./components/layout/Header"
import Footer from "./components/layout/Footer"
// import BackToTop from "./components/BackToTop"
import GoTop from '@inotom/vue-go-top';
import FormWidget from "./components/FormWidget"
import './assets/css/main-style.css'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    GoTop,
    FormWidget
  },
  data: () => {
    return {
      
    }
  },
  updated: function() {
     
  },
  
}
</script>

<style>
  html, body {
  height: 100%;
}
#mainWrapperApp {
  display: flex;
  flex-direction: column;
  margin: 0;
  height: 100vh;
}
#searchPageWrapper {
  flex: 1 0 auto;
}
footer {
  flex-shrink: 0;
}
.vue-go-top {
  opacity: 0.7;
}
.vue-go-top:hover,
.vue-go-top:focus{
  outline: none;
}
</style>
